export function obterListaOrigemMercadoria() {
  return (
    [
      { label: 'Nacional', value: '0' },
      { label: 'Estrangeira Importação Direta', value: '1' },
      { label: 'Estrangeira Adquirida no Mercado Interno', value: '2' },
    ]
  );
}
